import React from 'react';
import { useSearchParams } from 'react-router-dom';
import FilterSelect from '../../../shared/FilterSelect';
import { Button } from '@mui/material';
import { Badge, Label } from 'flowbite-react';
import Select from 'react-select';
import { ApplicationStatus } from 'types';

export const userOfferStatusOptions = [{ value: ApplicationStatus.OFFER_ROLLED_OUT, label: 'Offer Rolled Out' }];

const DriveUserOfferStatusFilterInput = ({ showSelect }: { showSelect?: boolean }) => {
	const [searchParams, setSearchParams] = useSearchParams();
	const offerStatus = JSON.parse(searchParams.get('offerStatus') || '[]');

	const options = userOfferStatusOptions;

	return (
		<>
			{!showSelect ? (
				<FilterSelect
					arrow={false}
					active={!!offerStatus?.length}
					placeholder={'Offer Status'}
					onClose={() => {}}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'left',
					}}
					transformOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}}
				>
					{({ handlePopoverClose }) => (
						<div className="min-w-[255px] bg-white dark:bg-[#1F2A37] py-2 ml-auto">
							{options?.map((option, i) => (
								<Button
									key={i}
									sx={{
										textAlign: 'left',
										display: 'block',
										py: '8px',
										width: '100%',
										px: '18px',
										fontSize: '14px',
										fontWeight: '400',
										color: 'inherit',
										borderRadius: '0',
										textTransform: 'none',
										'&:hover': { backgroundColor: '#7777e73f' },
										backgroundColor: offerStatus?.includes(option?.value?.toString()) ? '#7777e71b' : 'transparent',
									}}
									onClick={() => {
										// if (handlePopoverClose) handlePopoverClose();
										if (offerStatus?.includes(option?.value?.toString())) {
											searchParams.set(
												'offerStatus',
												JSON.stringify(offerStatus?.filter((status: string) => status !== option?.value?.toString())),
											);
											setSearchParams(searchParams);
											return;
										}
										searchParams.set('offerStatus', JSON.stringify([...offerStatus, option?.value?.toString()]));
										setSearchParams(searchParams);
									}}
								>
									<span>{option?.label}</span>
									{offerStatus?.includes(option?.value?.toString()) ? (
										<Badge className="rounded-[6px] font-[500] text-xs inline-flex w-fit ml-1" size="xs" color="dark">
											Selected
										</Badge>
									) : null}
								</Button>
							))}
						</div>
					)}
				</FilterSelect>
			) : (
				<div>
					<Label className="mb-1 inline-block">Offer Status</Label>
					<Select
						isMulti
						menuPosition="fixed"
						placeholder="Offer Status"
						className="flowbite-select--md"
						classNamePrefix="flowbite-select"
						options={options}
						value={options?.filter(option => offerStatus?.includes(option?.value?.toString()))}
						onChange={option => {
							searchParams.set('offerStatus', JSON.stringify(option?.map((option: any) => option?.value?.toString())));
							setSearchParams(searchParams);
						}}
					/>
				</div>
			)}
		</>
	);
};

export default DriveUserOfferStatusFilterInput;
